import { render, staticRenderFns } from "./ProductSummaryComponent.vue?vue&type=template&id=366ce3f2&scoped=true&"
import script from "./ProductSummaryComponent.vue?vue&type=script&lang=js&"
export * from "./ProductSummaryComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductSummaryComponent.vue?vue&type=style&index=0&id=366ce3f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366ce3f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardTitle,VChip,VIcon,VImg})
